import React from 'react';

class Loading extends React.Component {
  render() {
    return <div className="animated fadeIn pt-1 text-center">Loading...</div>;
  }
}

export default Loading;
